import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Navigate, useParams } from 'react-router-dom'
import { selectIsGuest } from 'store/shipping/shippingSelectors'
import { setHashPin } from 'store/shipping/shippingSlice'
import PropTypes from 'prop-types'

const GuestRoute = ({ element }) => {
  const { t, i18n } = useTranslation()
  const { language } = i18n
  const isGuest = useSelector(selectIsGuest)
  const dispatch = useDispatch()
  const { pin } = useParams()

  if (typeof pin !== 'undefined' && pin) {
    dispatch(setHashPin(pin))
  }

  if (isGuest === null) {
    return <div>{t('verification_messages.loading')}</div>
  }

  if (!isGuest) {
    return <Navigate to={`/rs/tr/${language}/home`} replace />
  }
  return element
}

GuestRoute.propTypes = {
  element: PropTypes.node.isRequired,
}

export default GuestRoute
